import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Select, Button, Row, Col, Avatar } from "antd";
import Main from "../../components/layout/Main";
import OrderImage from "../../assets/images/eyrbuds-image.png";
import CoineIcon from "../../assets/images/coin-image.svg";
import { ShoppingCart } from "lucide-react";
import { useNavigate } from "react-router";
import { useStore } from "../../context/StoreContext";
import { Severty, ShowToast } from "../../helper/toast";
import RefundedItem from "../../components/RefundedItem";

const OrderIndex = () => {
  const navigate = useNavigate();
  const { loadOrders, reOrder } = useStore();
  const [orders, setOrders] = useState([]);
  const [order, setOrder] = useState({});
  const [returnOpen, setReturnOpen] = useState(false);

  // ------------ handlers ------------
  const fetchOrders = async () => {
    const response = await loadOrders();
    setOrders(response.data.data);
  };

  const handleReOrder = async (orderId) => {
    const response = await reOrder(orderId);
    if (response.status === 200 || response.status === 201) {
      ShowToast(
        response.message || "Order reordered successfully",
        Severty.SUCCESS
      );
    }
  };

  const handleRefundRequest = async () => {
    console.log("open request refund");
  };

  // ------------ use effect ------------
  useEffect(() => {
    fetchOrders();
  }, []);

  return (
    <Main>
      <div className="order-section section-main">
        <h6 className="orange-header">Your Orders</h6>
        <div className="order-card-grid">
          {orders.map((order, index) => (
            <div className="order-card-box" key={index}>
              <div className="order-card-header">
                <div className="order-card-header-leftbar">
                  <h6>Order {order.orderId}</h6>
                  <p>{order.date}</p>
                </div>
                <div className="order-card-header-rightbar">
                  <Button
                    className="delivery-sucses-btn"
                    style={{
                      backgroundColor:
                        order.status === "Delivered" ? "#10A000" : "#FF9355",
                    }}
                  >
                    {order.status}
                  </Button>
                </div>
              </div>
              <div
                className="order-card-body"
                onClick={() => navigate(`/your-order-detail/${order.id}`)}
              >
                <div className="order-image">
                  <img src={OrderImage} alt="order-image" />
                </div>
                <div className="order-card-body-contant">
                  <h6>{order.title}</h6>
                  <p>{order.itemsCount} items</p>
                  <div className="total-card-count">
                    <img src={CoineIcon} alt="coine" />
                    <span>{order.amount}</span>
                  </div>
                </div>
              </div>
              {order?.refundRequests?.length > 0 && (
                <div
                  className="refund-banner refund-status-banner"
                  onClick={() => {
                    setReturnOpen(true);
                    setOrder(order);
                  }}
                >
                  <i className="icon-info">i</i>
                  <span>
                    Refund requested for {order?.refundRequests.length} item(s)
                  </span>
                </div>
              )}
              <div className="order-card-footer">
                {order.status === "delivered" ||
                order.status === "Delivered" ? (
                  <Button
                    type="default"
                    className="track-order-button"
                    onClick={() => {
                      handleReOrder(order?.id);
                      navigate("/checkout");
                    }}
                  >
                    <ShoppingCart /> Reorder
                  </Button>
                ) : (
                  <Button
                    type="default"
                    className="track-order-button"
                    onClick={() => navigate(`/your-order-detail/${order.id}`)}
                  >
                    Track order
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* --------- Return Modal ---------- */}
      <RefundedItem
        open={returnOpen}
        onClose={() => setReturnOpen(false)}
        order={order}
        onSubmit={handleRefundRequest}
      />
    </Main>
  );
};

export default OrderIndex;
